import createStore from './createStore';
export const useStoreVolet = createStore('volet');
